import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  jump({ target }) {
    window.location = target.value
  }
}
